// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { color, mergeWithCss, xScreen } from "@flip/XDL/Utilities";
import { orderUploadStyles } from "@insite/content-library/Components/OrderUpload";
import { StyledButton } from "@insite/mobius/Clickable";
import { IconWrapper } from "@insite/mobius/Icon";
import { css } from "styled-components";

// XNG-Changes: FLIP-979
orderUploadStyles.downloadTemplateButton = {
    ...orderUploadStyles.downloadTemplateButton,
    variant: "primary",
    css: css`
        margin-bottom: 15px;
        ${xScreen("lt", "xs")} {
            width: 100%;
        }
    `,
};

orderUploadStyles.fileUploader = {
    ...orderUploadStyles.fileUploader,
    buttonProps: {
        variant: "primary",
    },
};
// XNG-Changes
orderUploadStyles.uploadFileButtonLabel = {
    ...orderUploadStyles.uploadFileButtonLabel,
    color: "text",
};

// XNG-Changes: FLIP-980
orderUploadStyles.orderCancellationSuccessfulText = {
    color: "success",
    css: css`
        line-height: 25px;
    `,
};
